import React, { useEffect, useLayoutEffect, useState } from 'react'
import Empty from '../../components/Display/Empty'
import CheckAnimation from '../../assets/animations/check.json'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import { changeUserSubscriptionData } from '../../redux/actions/authentication'

const server = process.env.REACT_APP_SERVER_URL
const SuccessStripe : React.FC<any> = () => {

  const [divElement, setDivElement] = useState<any>(null)

  useLayoutEffect(() => {
    let mytimer = setInterval(() => {
    let widget = document.getElementById("fc_widget")
    if (widget) {
      clearInterval(mytimer);
      setDivElement(widget);
    }
    }, 500)
  }, [divElement])

  useEffect(() => {
    if (divElement) {
        divElement.style.display = 'none'
      }
  }, [divElement])
  
  const dispatch = useDispatch()

  const getTenantInfo = async () => {
    let response = await axios.get(`${server}/user/tenant`)
    const { plan, subscriptionEnd, subscriptionType } = response?.data?.tenant
    dispatch(changeUserSubscriptionData(plan, new Date(subscriptionEnd), subscriptionType))
  }

  useEffect(() => {
    getTenantInfo()
  }, [])
  

  return (
    <div className="flex flex-col justify-center items-center h-full">
            <h1>Este pago ha sido realizado satisfactoriamente</h1>
            <Empty
              isFromLoading={true}
              animationProps={{
                height: 200,
                width: 200,
                animation: CheckAnimation,
              }}
              lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
              loop={false}
            ></Empty>
          </div>
  )
}

export default SuccessStripe